import { Button, ButtonsGroup, Typo } from "#/atoms";
import { FC, memo, useCallback } from "react";

import { ChoiceProps } from "./Choice.interface";
import { DESKTOP_SPACING } from "@/theme";
import { Modal } from "#/molecules";

const Choice: FC<ChoiceProps> = ({ choice1Text, choice2Text, description, onChoice1, onChoice2, onClose, title }) => {
  const handleChoice1 = useCallback(() => {
    onChoice1();
    onClose();
  }, []);

  const handleChoice2 = useCallback(() => {
    onChoice2();
    onClose();
  }, []);

  return (
    <Modal onClose={onClose} title={title} width={'600px'}>
      <Typo>{description}</Typo>
      <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
        <Button buttonColor="primary" actionType="outline" onClick={handleChoice1}>{choice1Text}</Button>
        <Button onClick={handleChoice2}>{choice2Text}</Button>
      </ButtonsGroup>
    </Modal>
  );
};

export default memo(Choice);